<template>
  <b-form-group
    label="Hesap No"
    label-for="account_code"
  >
    <validation-provider
      #default="{ errors }"
      name="Hesap No"
      rules="required"
    >
      <b-form-input
        id="branch_code"
        v-model="dataItem.account_code"
        placeholder="Hesap No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'AccountCode',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
